import { Button, Link, Stack, Typography } from '@mui/material';
import type { Customer } from '@vy/types';
import { formatNumber, isEmptyArray } from '@vy/utils';

type CustomerNavMetaProps = {
  customerSource: string;
  externalLinkUrl?: string;
  externalLinkLabel: string | null;
  relatedCustomers?: Customer[];
  onRelatedEntitiesClick: () => void;
};

export const CustomerNavMeta: React.FC<CustomerNavMetaProps> = ({
  customerSource,
  externalLinkUrl,
  externalLinkLabel,
  relatedCustomers,
  onRelatedEntitiesClick,
}) => (
  <Stack
    sx={{
      marginTop: "42px",
      marginLeft: "16px"
    }}>
    <Typography
      sx={{
        fontWeight: 400,
        marginBottom: "4px",
        fontSize: 12,
        color: "text.secondary"
      }}>
      Origin: {customerSource}
    </Typography>

    {externalLinkUrl && (
      <Link
        href={externalLinkUrl}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{
          fontSize: 12,
          marginBottom: "4px"
        }}>
        {externalLinkLabel}
      </Link>
    )}

    <Button
      variant="text"
      disabled={isEmptyArray(relatedCustomers)}
      onClick={onRelatedEntitiesClick}
      sx={{
        color: 'text.secondary',
        fontSize: '12px',
        fontWeight: 400,
        padding: '0px',
        '&.Mui-disabled': { color: 'text.secondary' },
      }}
    >
      Related entities:
      <span style={{ color: '#0535E4', marginLeft: '5px' }}>{formatNumber(relatedCustomers?.length)}</span>
    </Button>
  </Stack>
);
